import { render, staticRenderFns } from "./OrganizationSummaryTable.vue?vue&type=template&id=6afa9773&scoped=true"
import script from "./OrganizationSummaryTable.vue?vue&type=script&lang=js"
export * from "./OrganizationSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSummaryTable.vue?vue&type=style&index=0&id=6afa9773&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa9773",
  null
  
)

export default component.exports